module.exports = __webpack_public_path__ + "img/cave103.20851eb3.jpg";